import React, {FC, memo} from "react";
import {Input, Space, Tooltip} from "antd";
import {InfoCircleTwoTone} from "@ant-design/icons";
import {GetBookingsByCourseIdWithCourseLessonBookingsQuery} from "../../../generated/graphql";
import i18n from "../../../services/i18n";
import {isDefined} from "../../../helpers/typeScriptHelpers";
import {renderAdditionalInfo} from "../../../views/TableColumnRenderers/TableColumnRenderers";
import css from "./LessonBookings.less";

type NotesProps = {
    booking: GetBookingsByCourseIdWithCourseLessonBookingsQuery["bookingsByCourseIdWithCourseLessonBookings"][0];
    // Rechte Spalte der Vorschau „Neu“: die Notiz Mitarbeiterin wird mit der Kursanpassung gespeichert (Stufe 4).
    staffNote?: string | null;
    onStaffNoteChange?: (value: string) => void;
};

const Notes: FC<NotesProps> = ({booking, staffNote, onStaffNoteChange}) => {
    return (
        <div className={css.notes}>
            <div className={css.container}>
                <div className={css.halfWidth}>
                    <div>{i18n.containers.bookings.BookingSteps.bookingNotice()}</div>
                    <Input.TextArea
                        rows={2}
                        disabled
                        value={isDefined(booking.noticeBooker) ? booking.noticeBooker : ""}
                    />
                </div>
                <div className={css.halfWidth}>
                    <div>{i18n.containers.bookings.BookingSteps.staffNotice()}</div>
                    {onStaffNoteChange ? (
                        <Input.TextArea
                            aria-label="Notiz"
                            maxLength={Math.max(2000, (booking.noticeStaff ?? "").length)}
                            value={staffNote ?? (isDefined(booking.noticeStaff) ? booking.noticeStaff : "")}
                            onChange={(event) => onStaffNoteChange(event.target.value)}
                        />
                    ) : (
                        <Input.TextArea disabled value={isDefined(booking.noticeStaff) ? booking.noticeStaff : ""} />
                    )}
                </div>
                <div className={css.fullWidth}>
                    <Space style={{fontWeight: 600}}>
                        {i18n.containers.bookings.BookingSteps.additionalInfo.label()}
                        <Tooltip
                            title={i18n.containers.bookings.BookingSteps.additionalInfo.tooltip()}
                            trigger={["click", "hover"]}
                        >
                            <InfoCircleTwoTone />
                        </Tooltip>
                    </Space>
                    <div className={css.additionalInfo}>
                        {renderAdditionalInfo({additionalInfo: booking.additionalInfo})}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(Notes);
